import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import { check_permission } from './acl'

import Home from '../views/user/Home.vue'
import Login from '../views/user/Login.vue'
import GoogleOAuthHandling from '../views/user/GoogleOAuthHandling.vue'
import MainMenu from '../views/user/MainMenu.vue'
import GraduateOfficerMenu from '../views/user/GraduateOfficerMenu.vue'

import ConfigAcademic from '../views/configs/ConfigAcademic.vue'
import ConfigSchedulePermission from '../views/configs/ConfigSchedulePermission.vue'
import ConfigPayment from '../views/configs/ConfigPayment.vue'
// import ConfigMedicine from '../views/configs/ConfigMedicine.vue'
import ConfigIndividualTuitionFee from '../views/configs/ConfigIndividualTuitionFee.vue'
import ConfigTeachTable from '../views/config_teach_table/ConfigTeachTable.vue'
import ConfigGraduateSeparateThesisCredit from '../views/configs/ConfigGraduateSeparateThesisCredit.vue'
import ConfigGraduateCurriculumFee from '../views/configs/ConfigGraduateCurriculumFee.vue'

import TeachTable from '../views/teach_table/TeachTable.vue'
import TeachTableSelector from '../views/teach_table/TeachTableSelector.vue'

import Information from '../views/registration/Information.vue'
import PreRegistration from '../views/registration/PreRegistration.vue'
import Registration from '../views/registration/Registration.vue'
import StudentTimetable from '../views/registration/StudentTimetable.vue'
import RoomTimetable from '../views/registration/RoomTimetable.vue'
import StudentExamTimetable from '../views/registration/StudentExamTimetable.vue'
import StudentExamSeatMap from '../views/registration/StudentExamSeatMap.vue'
import RegistrationX from '../views/registration/RegistrationX.vue'
import RegistrationForOfficer from '../views/registration/RegistrationForOfficer.vue'
import RegistrationQueue from '../views/registration/RegistrationQueue.vue'
import MaintainAndLeave from '../views/registration/MaintainAndLeave.vue'
import AcademicDataEdit from '../views/registration/AcademicDataEdit.vue'

import Payment from '../views/payment/Payment.vue'
import PaymentOfficer from '../views/payment/PaymentOfficer.vue'
import PaymentSlip from '../views/payment/PaymentSlip.vue'

import StatisticSplitCurr from '../views/report/StatisticSplitCurr.vue'

import ReportStudent from '../views/report_osda/ReportStudent.vue'
import ReportXStudent from '../views/report_osda/ReportXStudent.vue'
import ReportStudentDisability from '../views/report_osda/ReportStudentDis.vue'
import ReportStudentIslam from '../views/report_osda/ReportStudentIslam.vue'
import ReportStudentInter from '../views/report_osda/ReportStudentInter.vue'
import StudentNotRegistered from '../views/report/StudentNotRegistered.vue'
import StudentDebtReport from '../views/report/StudentDebtReport.vue'

import QuestionView from '@/views/user/QuestionView.vue'

import EnglishSubmit from '@/views/english_submission/EnglishSubmit.vue'
import EnglishSubmitList from '@/views/english_submission/EnglishSubmitList.vue'
import EnglishSubmitVerify from '@/views/english_submission/EnglishSubmitVerify.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'home', component: Home },
  { path: '/login', name: 'login', component: Login },
  { path: '/google_oauth_handling', name: 'google_oauth_handling', component: GoogleOAuthHandling },
  { path: '/main_menu', name: 'main_menu', component: MainMenu },
  { path: '/graduate_officer_menu', name: 'graduate_officer_menu', component: GraduateOfficerMenu },

  { path: '/config_academic', name: 'config_academic', component: ConfigAcademic },
  { path: '/config_schedule_permission', name: 'config_schedule_permission', component: ConfigSchedulePermission },
  { path: '/config_payment', name: 'config_payment', component: ConfigPayment },
  // { path: '/config_medicine', name: 'config_medicine', component: ConfigMedicine },
  { path: '/config_individual_tuition_fee', name: 'config_individual_tuition_fee', component: ConfigIndividualTuitionFee },
  { path: '/config_teach_table', name: 'config_teach_table', component: ConfigTeachTable },
  { path: '/config_graduate_separate_thesis_credit', name: 'config_graduate_separate_thesis_credit', component: ConfigGraduateSeparateThesisCredit },
  { path: '/config_graduate_curriculum_fee', name: 'config_graduate_curriculum_fee', component: ConfigGraduateCurriculumFee },

  { path: '/teach_table', name: 'teach_table', component: TeachTable, props: { levelId: 1 } },
  { path: '/teach_table_selector', name: 'teach_table_selector', component: TeachTableSelector, props: { levelId: 1 } },
  { path: '/graduate_teach_table_selector', name: 'graduate_teach_table_selector', component: TeachTableSelector, props: { levelId: 2 } },
  { path: '/graduate_teach_table', name: 'graduate_teach_table', component: TeachTable, props: { levelId: 2 } },

  { path: '/information', name: 'information', component: Information },
  { path: '/pre_registration', name: 'pre_registration', component: PreRegistration },
  { path: '/registration', name: 'registration', component: Registration },
  { path: '/student_timetable', name: 'student_timetable', component: StudentTimetable },
  { path: '/room_timetable', name: 'room_timetable', component: RoomTimetable },
  { path: '/student_exam_timetable', name: 'student_exam_timetable', component: StudentExamTimetable },
  { path: '/student_exam_timetable/seat', name: 'student_exam_timetable_seat', component: StudentExamSeatMap },
  { path: '/registration_future_innovation', name: 'registration_future_innovation', component: RegistrationX },
  { path: '/registration_x', name: 'registration_x', component: RegistrationX },
  { path: '/registration_for_officer', name: 'registration_for_officer', component: RegistrationForOfficer },
  { path: '/registration_queue', name: 'registration_queue', component: RegistrationQueue },
  { path: '/maintain_and_leave', name: 'maintain_and_leave', component: MaintainAndLeave },
  { path: '/academic_data_edit', name: 'academic_data_edit', component: AcademicDataEdit },

  { path: '/payment', name: 'payment', component: Payment },
  { path: '/payment_officer', name: 'payment_officer', component: PaymentOfficer },
  { path: '/payment_slip', name: 'payment_slip', component: PaymentSlip },

  { path: '/statistic_split_curr', name: 'statistic_split_curr', component: StatisticSplitCurr },
  { path: '/report_student', name: 'report_student', component: ReportStudent },
  { path: '/report_x_student', name: 'report_x_student', component: ReportXStudent },
  { path: '/report_student_disability', name: 'report_student_disability', component: ReportStudentDisability },
  { path: '/report_student_islam', name: 'report_student_islam', component: ReportStudentIslam },
  { path: '/report_student_inter', name: 'report_student_inter', component: ReportStudentInter },
  { path: '/report_student_not_registered', name: 'report_student_not_registered', component: StudentNotRegistered },
  { path: '/student_debt_report', name: 'student_debt_report', component: StudentDebtReport },

  { path: '/questionnaire', name: 'questionnaire', component: QuestionView },

  { path: '/english_submit', name: 'english_submit', component: EnglishSubmit },
  { path: '/english_submit_list', name: 'english_submit_list', component: EnglishSubmitList },
  { path: '/english_submit_verify', name: 'english_submit_verify', component: EnglishSubmitVerify },
]

const router = new VueRouter({
  routes
})

router.beforeEach(async (to, from, next) => {
  // รอ API getUserInfo ทำงานเสร็จ
  if (store.state.user.is_authen === null) {
    await new Promise((resolve) => {
      const unwatch = store.watch(
        (state) => state.user.is_authen,
        (newValue) => {
          if (newValue !== null) {
            unwatch();
            resolve();
          }
        }
      );
    });
  }

  // เช็คสิทธิ์การเข้าถึงหน้านั้น ๆ ถ้าไม่มีสิทธิ์ให้ไปหน้า information
  if (!check_permission([to.name])) {
    next('/information');
    return;
  }

  // ถ้าเข้าหน้า login แต่ authen แล้ว ให้ไปหน้า index
  if (to.name === 'login' && store.state.user.is_authen) {
    next('/');
    return;
  }

  next();
});


export default router
